<hr class="mt-2 mb-2" />
<div class="alert alert-info py-2 px-3 mb-1">
  <strong>Pedido(s) Pendência vinculado(s)</strong>
</div>
<div class="table-responsive">
  <table class="table table-sm table-bordered">
    <thead class="thead-light">
      <tr>
        <th class="text-center">Nº Pedido</th>
        <th class="text-center">Status Aprovação</th>
        <th class="text-center">Dt. Criação</th>
      </tr>
    </thead>
    <tbody>
      @for (pp of pedidosPendencia; track pp) {
        <tr>
          <td class="text-center"><b>{{ pp.order_id_app }}</b></td>
          <td class="text-center">{{ pp.status_aprovacao_master || '—' }}</td>
          <td class="text-center">{{ pp.order_created_at | date: 'dd/MM/yyyy' }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
